import { colorsCommon } from './colorsCommon';
export const miscTokensCommon = {
  transitions: {
    medium: 'all .5s ease',
    fast: 'all .3s ease'
  },
  border: {
    radius: {
      xs: {
        value: 4,
        unit: 'px'
      },
      s: {
        value: 8,
        unit: 'px'
      },
      m: {
        value: 16,
        unit: 'px'
      },
      l: {
        value: 24,
        unit: 'px'
      }
    },
    width: {
      s: {
        value: 1,
        unit: 'px'
      },
      m: {
        value: 2,
        unit: 'px'
      }
    }
  },
  shadows: {
    'drop-0': '0px 1px 2px rgba(0, 0, 0, 0.1)',
    'drop-1': '0px 1px 4px rgba(0, 0, 0, 0.2)',
    'drop-2': '0px 3px 6px rgba(0, 0, 0, 0.16)',
    'drop-3': '0px 4px 8px rgba(0, 0, 0, 0.14)',
    'drop-4': '1px 4px 8px rgba(0, 0, 0, 0.05), 0px 10px 16px rgba(0, 0, 0, 0.08)',
    'drop-5': '2px 4px 8px rgba(0, 0, 0, 0.06), 2px 14px 24px rgba(0, 0, 0, 0.1)',
    'spread-neutral': '0px 0px 0px 3px rgba(228, 228, 228, 0.5)',
    'spread-success': '0px 0px 0px 3px rgba(237, 245, 229, 0.78)',
    'spread-error': '0px 0px 0px 3px rgba(251, 226, 226, 0.78)',
    'spread-help': '0px 0px 0px 3px rgba(226, 239, 248, 0.78)',
    'spread-alert': '0px 0px 0px 3px rgba(251, 224, 181, 0.84)'
  },
  dimmer: {
    light: 'rgba(255, 255, 255, 0.9)',
    dark: 'rgba(58, 58, 58, 0.6);'
  },
  body: {
    background: {
      mobile: colorsCommon.neutralWarm200,
      mobileXl: colorsCommon.neutralWarm200,
      tablet: colorsCommon.white,
      desktop: colorsCommon.white
    }
  }
};
//# sourceMappingURL=miscCommon.js.map